import moment from 'moment';
import BaseAPIClient from './base/BaseAPIClient';

export default class SessionClient extends BaseAPIClient {

    createRequest(userId, counselorId, start, end, autoPayWithCredit) {
        return this._post('v2/counseling/session/request/', {
            userId, 
            counselorId,
            start,
            end,
            autoPayWithCredit,
        })
    }

    approveRequest(sessionRequestId) {
        return this._post('v2/counseling/session/approve-request/', {
            sessionRequestId
        })
    }

    cancelRequest(sessionRequestId) {
        return this._post('v2/counseling/session/cancel-request/', {
            sessionRequestId
        })
    }

    declineRequest(sessionRequestId, explanation) {
        return this._post('v2/counseling/session/decline-request/', {
            sessionRequestId,
            explanation
        })
    }

    rescheduleSession(sessionId, start, end) {
        if(moment.isMoment(start))
            start = start.toISOString();
        if(moment.isDate(start))
            start = start.toISOString();
        if(moment.isMoment(end))
            end = end.toISOString();
        if(moment.isDate(end))
            end = end.toISOString();

        return this._post(
            'v2/counseling/session/reschedule', 
            { sessionId, start, end })
    }

    cancelSessionByBetterMyndAdmin(sessionId) {
        return this._post(
            'v2/counseling/session/cancel/bettermynd-admin', 
            { sessionId })
    }
    cancelSessionByUser(sessionId) {
        return this._post(
            'v2/counseling/session/cancel/user', 
            { sessionId })
    }
    cancelSessionByCounselor(sessionId) {
        return this._post(
            'v2/counseling/session/cancel/counselor', 
            { sessionId })
    }

    getSessionsForCounselor(counselorId, searches, from, through, recordCount, pageToken, canceled) {
        return this._get('v2/counseling/sessions/counselors/',{
            counselorId,
            from,
            through,
            searches,
            recordCount,
            canceled,
            pageToken
        });
    }
    getSessionsForUser(userId, from, through, canceled, recordCount, pageToken) {
        return this._get('v2/counseling/sessions/users/',{
            userId,
            from,
            through,
            canceled,
            recordCount,
            pageToken
        });
    }
    getSessionsForAdmin(from, through, searches, canceled, recordCount, pageToken) {
        return this._get('v2/counseling/sessions/admins/',{
            searches,
            from,
            through,
            canceled,
            recordCount,
            pageToken
        });
    }
    getOutcomesForAdmin(from, through, searches, outcomesFilter, recordCount, pageToken) {
        return this._get('v2/counseling/session/outcomes/', {
            searches,
            from,
            through,
            outcomes: outcomesFilter,
            recordCount,
            pageToken,
        });
    }

    getSessionOutcomesDrillDownReport(schoolId, userId, from , through) {
        return this._get('v2/counseling/session/outcomes/campus-admin-report', {
            schoolId,
            userId,
            from,
            through
        });
    }

    getSessionOutcomeMetrics(schoolId, from, through, includedOutcomes, customCampusTags, searches) {
        return this._get('v2/counseling/session/outcomes/outcome-metrics', {
            schoolId,
            from,
            through,
            includedOutcomes,
            customCampusTags,
            searches
        });
    }
    updateOutcome(sessionId, newOutcome, publicExplainer, internalExplainer) {
        return this._post('v2/counseling/session/outcomes/', {
            sessionId,
            newOutcome,
            publicExplainer,
            internalExplainer,
        })
    }
}
